import { createMuiTheme } from "@material-ui/core/styles";

export const whitelabel = {
	theme: (utilityConfig) => {
		let theme = createMuiTheme({
			palette: {
				primary: {
					main: utilityConfig.theme.colors.primary,
					contrastText: "#FFFFFF",
				},
				secondary: {
					main: utilityConfig.theme.colors.secondary,
					contrastText: "#FFFFFF",
				},
				error: {
					main: "#D73C3C",
					contrastText: "#FFFFFF",
				},
				success: {
					main: "#038360",
					contrastText: "#FFFFFF",
				},
				text: {
					primary: "#364256",
					secondary: "#4F4F4F",
					disabled: "#D7D7D7",
				},
				background: {
					default: utilityConfig.theme.colors.mainBackground,
				},
			},
			overrides: {
				MuiButton: {
					// Name of the styleSheet
					root: {
						// Name of the rule
					},
					contained: {
						color: "#FFFFFF",
						backgroundColor: utilityConfig.theme.colors.primary,
						borderRadius: "4px",
						padding: "5px 20px",
						"&:hover": {
							backgroundColor: utilityConfig.theme.colors.primary80,
						},
					},
					outlined: {
						color: utilityConfig.theme.colors.primary,
						borderRadius: "4px",
						border: `1px solid ${utilityConfig.theme.colors.primary}`,
						padding: "5px 20px",
					},
					text: {
						padding: "10px 49px",
					},
				},
				MuiOutlinedInput: {
					input: {
						padding: "5px 20px",
					},
				},
			},
			typography: {
				fontFamily: ["Montserrat", "sans-serif"].join(","),
				fontSize: 18,
				fontStyle: "normal",
				fontWeight: 400,
				button: {
					fontSize: 16,
					lineHeight: "25px",
					fontWeight: 600,
					textTransform: "none",
				},
			},
			breakpoints: {
				values: utilityConfig.theme.breakpoints,
			},
		});

		return theme;
	},
	cssVariables: (utilityConfig) => {
		return {
			"--css-vars-ponyfill-hack": "none", // required to workaround a weird bug in css-vars-ponyfill where css has to have at least 1 var.  see: https://github.com/jhildenbiddle/css-vars-ponyfill/issues/147
			"--app-background-color": utilityConfig.theme.colors.mainBackground,
			"--custom-replace-content-width-xs": utilityConfig.theme.breakpoints.xs + "px",
			"--custom-replace-content-width-sm": utilityConfig.theme.breakpoints.sm + "px",
			"--custom-replace-content-width-md": utilityConfig.theme.breakpoints.md + "px",
			"--custom-replace-content-width-lg": utilityConfig.theme.breakpoints.lg + "px",
			"--custom-replace-screen-max-width-xs": utilityConfig.theme.breakpoints.xs - 1 + "px",
			"--custom-replace-screen-max-width-sm": utilityConfig.theme.breakpoints.sm - 1 + "px",
			"--custom-replace-screen-max-width-md": utilityConfig.theme.breakpoints.md - 1 + "px",
			"--custom-replace-screen-max-width-lg": utilityConfig.theme.breakpoints.lg - 1 + "px",
			"--color-primary": utilityConfig.theme.colors.primary,
			"--color-secondary": utilityConfig.theme.colors.secondary,
			...utilityConfig.theme.cssVars,
		};
	},
	stringResources: (utilityConfig) => {
		return utilityConfig.resources.strings;
	},
};
